export const DEFAULT_SESSION_TTL = 3600000;

// Lifetime of the HttpOnly auth cookie (`session-token`) — aligned with the
// gateway's Redis session (30 days). It used to be DEFAULT_SESSION_TTL
// (1 hour): the browser silently dropped the cookie while the session (and
// the localStorage copy) stayed valid, so client requests kept working while
// SSR prefetches (e.g. /store/template) were sent without a token and got
// 403. keepAlive additionally re-issues the cookie on activity so it slides
// with the session.
export const AUTH_COOKIE_TTL = 30 * 24 * 60 * 60 * 1000;
